import '.fn{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fo{padding-left:1.5rem;}.ssr-plugin'
import '.fp{margin:1rem 0;}.ssr-plugin'
import '.fq{color:var(--gray-700);}.ssr-plugin'
import '.fr{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fn fo fp fq fr"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
